import { render, staticRenderFns } from "./BerkleyProposalStatus.vue?vue&type=template&id=235adb60"
import script from "./BerkleyProposalStatus.vue?vue&type=script&lang=js"
export * from "./BerkleyProposalStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports